import { render, staticRenderFns } from "./TopicsForm.vue?vue&type=template&id=2cb09566&scoped=true"
import script from "./TopicsForm.vue?vue&type=script&lang=js"
export * from "./TopicsForm.vue?vue&type=script&lang=js"
import style0 from "./TopicsForm.vue?vue&type=style&index=0&id=2cb09566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb09566",
  null
  
)

export default component.exports